export const leftIconContainerCommonStyles = (FOUNDATIONS, FONT) => ({
    align_self: 'flex-start',
});
export const leftIconCommonStyles = (FOUNDATIONS, FONT) => ({
    width: FOUNDATIONS.size_300,
    height: FOUNDATIONS.size_300,
    color: FOUNDATIONS.color_comp_actions_iconbutton_secondary_default_icon,
    disabled: {
        width: FOUNDATIONS.size_300,
        height: FOUNDATIONS.size_300,
        color: FOUNDATIONS.color_accent_disabled_icon_100,
    },
});
export const clearIconContainerCommonStyles = (FOUNDATIONS, FONT) => ({
    align_self: 'flex-start',
});
export const clearIconCommonStyles = (FOUNDATIONS, FONT) => ({
    width: FOUNDATIONS.size_300,
    height: FOUNDATIONS.size_300,
    color: FOUNDATIONS.color_comp_actions_iconbutton_secondary_default_icon,
    disabled: {
        width: FOUNDATIONS.size_300,
        height: FOUNDATIONS.size_300,
        color: FOUNDATIONS.color_accent_disabled_icon_100,
    },
});
//# sourceMappingURL=icon.js.map